import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import { formatOptionalId } from './memberConstants';

export default function MemberAgentEditModal({ open, row, onClose, onSaved }) {
  const [inviterId, setInviterId] = useState('');
  const [promotionCode, setPromotionCode] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [refreshingCode, setRefreshingCode] = useState(false);

  useEffect(() => {
    if (open && row) {
      setInviterId(row.inviterId != null ? String(row.inviterId) : '');
      setPromotionCode(row.promotionCode || '');
      setError('');
      setSubmitting(false);
    }
  }, [open, row?.id, row?.inviterId, row?.promotionCode]);

  if (!open || !row) {
    return null;
  }

  async function handleRefreshCode() {
    setRefreshingCode(true);
    setError('');
    try {
      const code = await adminApi.memberRegeneratePromotionCode(row.id);
      setPromotionCode(code || '');
    } catch (err) {
      setError(err.message || '刷新邀請碼失敗');
    } finally {
      setRefreshingCode(false);
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (!inviterId.trim()) {
      setError('請輸入直屬上級用戶ID');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await adminApi.memberUpdate({
        id: row.id,
        inviterId: Number(inviterId),
      });
      onSaved?.();
      onClose?.();
    } catch (err) {
      setError(err.message || '更新失敗');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div className="admin-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal__header">
          <h3>代理資訊 [{formatOptionalId(row.id)}]</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-modal__body">
            <div className="form-field">
              <span className="form-label">用戶ID</span>
              <p className="form-static">{formatOptionalId(row.id)}</p>
            </div>
            <div className="form-field">
              <label htmlFor="memberAgentInviterId">
                直屬上級用戶ID
                <span className="form-required">*</span>
              </label>
              <input
                id="memberAgentInviterId"
                type="number"
                value={inviterId}
                onChange={(e) => setInviterId(e.target.value)}
                disabled={submitting}
              />
            </div>
            <div className="form-field">
              <span className="form-label">邀請碼</span>
              <div className="member-promotion-code-row">
                <input type="text" value={promotionCode} readOnly />
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  disabled={refreshingCode || submitting}
                  onClick={handleRefreshCode}
                >
                  {refreshingCode ? '刷新中…' : '刷新'}
                </button>
              </div>
            </div>
            {error && <div className="alert alert-error">{error}</div>}
          </div>
          <div className="admin-modal__footer">
            <button type="submit" className="btn btn-success" disabled={submitting}>
              {submitting ? '提交中…' : '提交'}
            </button>
            <button type="button" className="btn btn-warning" onClick={() => setInviterId('')} disabled={submitting}>
              重置
            </button>
            <button type="button" className="btn btn-danger" onClick={onClose} disabled={submitting}>
              關閉
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
